import Vue from "vue";
import Router from "vue-router";
import mainNav from "../navigation/mainNav";
import commonRoutes from "./commonRoutes";
const UndefinedPage = () => import("@/views/base/UndefinedPage.vue");
const DefaultContainer = () => import("@/containers/DefaultContainer");
Vue.use(Router);
const userAccess = {
  GENERAL: true,
  TECH_STAT: true,
  SALES: true,
  ISSUES: true,
  FNS: true,
  ACC_REC: true
};

const choosePaths = userAccess => {
  let childrenArray = [];
  let redirectPath = "";
  if (localStorage.getItem("fns_user")) {
    for (const [key, value] of Object.entries(userAccess)) {
      if (value) {
        if (redirectPath.length === 0) {
          redirectPath = mainNav[key].route.mainRoute;
        }
        childrenArray.push(...mainNav[key].route.children);
      }
    }
  }
  return {
    childrenArray: childrenArray,
    redirectPath: redirectPath
  };
};

const paths = choosePaths(userAccess);
const router = new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: paths.redirectPath,
      name: "Home",
      component: DefaultContainer,
      children: [...paths.childrenArray]
    },
    {
      path: "/pages",
      redirect: commonRoutes.mainRoute,
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [...commonRoutes.children]
    },
    {
      path: "*",
      name: "UndefinedPage",
      component: UndefinedPage
    }
  ]
});

export default router;
